/**
 * Exploded-view feature accordion
 * Click a feature row to expand description and highlight the matching
 * callout pin in the appliance image. Only one item open at a time.
 */
function toggleExploded(id) {
  const accordionItems = document.querySelectorAll('.exploded-item');
  const calloutPins = document.querySelectorAll('.exploded-callout');
  const targetItem = document.querySelector(`.exploded-item[data-id="${id}"]`);

  if (!targetItem) return;

  const isOpen = targetItem.classList.contains('open');

  // Reset all items and pins
  accordionItems.forEach(item => item.classList.remove('open'));
  calloutPins.forEach(pin => pin.classList.remove('active'));

  // Toggle state
  if (!isOpen) {
    targetItem.classList.add('open');
    const pin = document.querySelector(`.exploded-callout[data-id="${id}"]`);
    if (pin) pin.classList.add('active');

    // Auto-scroll on mobile/tablet where layout is stacked
    if (window.innerWidth <= 900) {
      setTimeout(() => {
        const headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 72;
        const stickyNav = document.querySelector('[data-scroll-nav].is-sticky');
        const navHeight = stickyNav ? stickyNav.offsetHeight : 0;
        
        const offset = headerH + navHeight + 20; // 20px breathing room
        const targetPosition = targetItem.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }, 50);
    }
  }
}
